export default {
  REGISTER_REPOSITORY: Symbol.for('REGISTER_REPOSITORY'),
  SIGN_UP_COMMAND: Symbol.for('SIGN_UP_COMMAND'),
};
